import { type FC } from 'react';
import { Badge } from '@mantine/core';
import { formatOrder, payoutOrderPriorityColors, type PayoutOrderPriority } from '~/entities/payout';

interface OrderPriorityBadgeProps {
    priority?: PayoutOrderPriority;
    fullWidth?: boolean;
}

export const OrderPriorityBadge: FC<OrderPriorityBadgeProps> = ({ priority, fullWidth = false }) => {
    if (!priority) {
        return null;
    }

    return (
        <Badge
            variant='dot'
            fullWidth={fullWidth}
            color={payoutOrderPriorityColors[priority]}
        >
            {formatOrder.priority(priority)}
        </Badge>
    );
};
